module.exports = __webpack_public_path__ + "img/20200422142847TIM截图20200422142752.0388b774.png";